export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_title_displayImportMsg') || '错误/警告信息',
    field: 'displayImportMsg',
    headerAlign: 'center',
    align: 'left',
    width: 280,
    slots: { default: 'displayImportMsg' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_purchaseMaterialNo') || '采购单号',
    field: 'purchaseMaterialNo',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_originOrderNo') || '源头订单号',
    field: 'originOrderNo',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_scmName') || '供方',
    field: 'scmName',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_buyerName') || '采购人员',
    field: 'buyerName',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_purchaseDate') || '制单日期',
    field: 'purchaseDate',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_totalAmount') || '采购金额',
    field: 'totalAmount',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_detailMaterial') || '采购物料',
    align: 'center',
    showHeaderOverflow: true,
    children: [
      {
        title: that.$l('form_label_materialNo') || '物料编码',
        field: 'detail.materialNo',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_materialName') || '物料名称',
        field: 'detail.materialName',
        align: 'center',
        width: 150,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_cd') || 'CD#',
        field: 'detail.cd',
        align: 'center',
        width: 150,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_materialDesc') || '规格型号尺寸',
        field: 'detail.materialDesc',
        headerAlign: 'center',
        align: 'left',
        width: 150,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_materialRequirement') || '材质要求',
        field: 'detail.materialRequirement',
        headerAlign: 'center',
        align: 'left',
        width: 150,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_qty') || '数量',
        field: 'detail.qty',
        align: 'center',
        width: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_qtyUnit') || '单位',
        field: 'detail.qtyUnit',
        align: 'center',
        width: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_unitPrice') || '含税单价',
        field: 'detail.unitPrice',
        headerAlign: 'center',
        align: 'left',
        width: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_subAmount') || '价税合计',
        field: 'detail.subAmount',
        headerAlign: 'center',
        align: 'left',
        width: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_planArrivalDate') || '计划到货日期',
        field: 'detail.planArrivalDate',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
      },
    ],
  },
]
